import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Loader } from '@adsk/bim360-matrix-react-components';
import { issueWrapperArrayType } from '../../../../constants/proptype-validation';
import IssueSummary from './components/IssueSummary';

export default class IssuesList extends PureComponent {
  render() {
    // eslint-disable-next-line react/prop-types
    const { issues, changeLocationAction, loading, onRFIClick } = this.props;

    return (
      <div className="IssuesList">
        {issues.map((issue) =>
          <IssueSummary
            key={issue.attributes.id}
            issue={issue.attributes}
            changeLocationAction={changeLocationAction}
            onRFIClick={onRFIClick}
          />
        )}

        {/* Render loading indication at bottom of list */}
        {loading
          ? <div className="IssuesList__loading-indicator">
            <Loader />
          </div> : null}
      </div>
    );
  }
}

IssuesList.displayName = 'IssuesList';

IssuesList.propTypes = {
  issues: issueWrapperArrayType.isRequired,
  loading: PropTypes.bool.isRequired,
  onRFIClick: PropTypes.func.isRequired,
};
